import React, { useRef, useState } from "react";
import DownloadExcel from "../../../Extra/DownloadExcel";
import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";
import {
  flattenData,
  getDaysBetweenMonths,
  secondsToHHMM,
} from "../../../Utilitie";

const STAYardMWData = ({ data }) => {
  const key = [
    "CC",
    "PREMIUM",
    "Intensive",
    "Total Rakes",
    "Total Exam Time",
    "Avg. Exam Time",
    "M-Sick",
    "ROH",
    "POH",
    "NPOH",
    "Total",
    "AVG Shunt Per Rakes",
  ];
  const tempData = data;

  const years = [...new Set(tempData.map((o) => o.F_YEAR))];
  const monthOrder = [
    "Apr",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];
  const tableRef = useRef();
  const table1 = useRef();
  const table2 = useRef();
  const table3 = useRef();
  const table4 = useRef();
  const table5 = useRef();
  const tableRefArray = [table1, table2, table3, table4, table5];
  const sum = (year, column) => {
    return tempData
      .filter((o) => o.F_YEAR === year)
      .reduce((s, o) => s + Number(o[column] || 0), 0);
  };

  const avg = (year, column) => {
    const items = tempData.filter((o) => o.F_YEAR === year);
    const total = items.reduce((s, o) => s + Number(o[column] || 0), 0);
    return items.length ? (total / items.length).toFixed(2) : 0;
  };
  const avg1 = (year, column) => {
    const items = tempData.filter(
      (o) => o.F_YEAR === `${year.slice(0, 4) - 1}-${year.slice(2, 4)}`,
    );
    const total = items.reduce((s, o) => s + Number(o[column] || 0), 0);
    return items.length ? (total / items.length).toFixed(2) : 0;
  };

  return (
    <div>
      {" "}
      <h6 className="p-3 bg-dark text-white">
        STA YARD EXAMINATION FINANCIAL YEAR WISE SUMMARY
      </h6>
      <div className="table-responsive">
        {years.map((year, ind) => {
          return (
            <div>
              <table
                ref={tableRefArray[years.indexOf(year)]}
                className="table table-bordered table-striped text-center "
                style={{ fontSize: "13px" }}
              >
                <thead>
                  <tr className="table-dark text-center">
                    <th></th>
                    <>
                      <th colSpan={12}> STA YARD EXAMINATION ({year})</th>
                    </>
                  </tr>
                  <tr
                    className="table-dark text-center"
                    style={{ fontWeight: "bold" }}
                  >
                    <th></th>
                    <>
                      <th colSpan={6}>EXAMINATION TYPE </th>
                      <th colSpan={6}>SICK MARKING </th>
                    </>
                  </tr>

                  <tr
                    className="table-dark text-center align-middle"
                    style={{ fontWeight: "bold" }}
                  >
                    <th>Month</th>

                    {key.map((Head, i) => (
                      <th
                        key={i}
                        style={{
                          whiteSpace: "normal",
                        }}
                      >
                        {Head}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody key={ind}>
                  {monthOrder.map((month, i) => {
                    let tempMonths = [
                      ...new Set(
                        tempData
                          .filter((x) => x.F_YEAR === year)
                          .map((x) => x.MONTH),
                      ),
                    ];

                    if (!tempMonths.includes(month)) return null;

                    const row = tempData.find(
                      (o) => o.F_YEAR === year && o.MONTH === month,
                    );

                    return (
                      <tr key={i}>
                        <td>{month}</td>
                        <td>{row?.EXAM_TYPE_CC || 0}</td>
                        <td>{row?.EXAM_TYPE_PREMIUM || 0}</td>
                        <td>{row?.EXAM_TYPE_INT || 0}</td>
                        <td>{row?.TOTAL_RAKES || 0}</td>
                        <td>{secondsToHHMM(row?.TOTAL_EXAM || 0)}</td>
                        <td>{secondsToHHMM(row?.TOTAL_RAKE_AVG || 0)}</td>

                        <td>{row?.SM_M_SICK || 0}</td>
                        <td>{row?.SM_ROH || 0}</td>
                        <td>{row?.SM_POH || 0}</td>
                        <td>{row?.SM_NPOH || 0}</td>
                        <td>{row?.SM_TOTAL || 0}</td>
                        <td>{row?.SM_AVG_SHUNT_PER_RAKE || 0}</td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr className="table-dark fw-bold">
                    <td>Total</td>

                    <td>{sum(year, "EXAM_TYPE_CC")}</td>
                    <td>{sum(year, "EXAM_TYPE_PREMIUM")}</td>
                    <td>{sum(year, "EXAM_TYPE_INT")}</td>
                    <td>{sum(year, "TOTAL_RAKES")}</td>
                    <td>{secondsToHHMM(sum(year, "TOTAL_EXAM"))}</td>
                    <td>{secondsToHHMM(sum(year, "TOTAL_RAKE_AVG"))}</td>

                    <td>{sum(year, "SM_M_SICK")}</td>
                    <td>{sum(year, "SM_ROH")}</td>
                    <td>{sum(year, "SM_POH")}</td>
                    <td>{sum(year, "SM_NPOH")}</td>
                    <td>{sum(year, "SM_TOTAL")}</td>
                    <td>{sum(year, "SM_AVG_SHUNT_PER_RAKE").toFixed(2)}</td>
                  </tr>

                  <tr className="table-dark fw-bold">
                    <td>Average</td>

                    <td>{avg(year, "EXAM_TYPE_CC")}</td>
                    <td>{avg(year, "EXAM_TYPE_PREMIUM")}</td>
                    <td>{avg(year, "EXAM_TYPE_INT")}</td>
                    <td>{avg(year, "TOTAL_RAKES")}</td>
                    <td>{secondsToHHMM(avg(year, "TOTAL_EXAM"))}</td>
                    <td>{secondsToHHMM(avg(year, "TOTAL_RAKE_AVG"))}</td>

                    <td>{avg(year, "SM_M_SICK")}</td>
                    <td>{avg(year, "SM_ROH")}</td>
                    <td>{avg(year, "SM_POH")}</td>
                    <td>{avg(year, "SM_NPOH")}</td>
                    <td>{avg(year, "SM_TOTAL")}</td>
                    <td>{avg(year, "SM_AVG_SHUNT_PER_RAKE")}</td>
                  </tr>
                  <tr className="table-dark fw-bold">
                    <td>Var %</td>

                    <td>
                      {(
                        ((avg(year, "EXAM_TYPE_CC") -
                          avg1(year, "EXAM_TYPE_CC")) /
                          avg1(year, "EXAM_TYPE_CC")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {(
                        ((avg(year, "EXAM_TYPE_PREMIUM") -
                          avg1(year, "EXAM_TYPE_PREMIUM")) /
                          avg1(year, "EXAM_TYPE_PREMIUM")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "EXAM_TYPE_INT") -
                          avg1(year, "EXAM_TYPE_INT")) /
                          avg1(year, "EXAM_TYPE_INT")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "TOTAL_RAKES") -
                          avg1(year, "TOTAL_RAKES")) /
                          avg1(year, "TOTAL_RAKES")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "TOTAL_EXAM") - avg1(year, "TOTAL_EXAM")) /
                          avg1(year, "TOTAL_EXAM")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %{" "}
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "TOTAL_RAKE_AVG") -
                          avg1(year, "TOTAL_RAKE_AVG")) /
                          avg1(year, "TOTAL_RAKE_AVG")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>

                    <td>
                      {" "}
                      {(
                        ((avg(year, "SM_M_SICK") - avg1(year, "SM_M_SICK")) /
                          avg1(year, "SM_M_SICK")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "SM_ROH") - avg1(year, "SM_ROH")) /
                          avg1(year, "SM_ROH")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "SM_POH") - avg1(year, "SM_POH")) /
                          avg1(year, "SM_POH")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "SM_NPOH") - avg1(year, "SM_NPOH")) /
                          avg1(year, "SM_NPOH")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "SM_TOTAL") - avg1(year, "SM_TOTAL")) /
                          avg1(year, "SM_TOTAL")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "SM_AVG_SHUNT_PER_RAKE") -
                          avg1(year, "SM_AVG_SHUNT_PER_RAKE")) /
                          avg1(year, "SM_AVG_SHUNT_PER_RAKE")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                  </tr>
                </tfoot>
              </table>{" "}
              <div className="mb-3">
                <DownloadExcel
                  tableRef={tableRefArray[years.indexOf(year)]}
                  fileName={`Financial Year Summary STA Yard Ex  - ${year}`}
                />
              </div>
            </div>
          );
        })}{" "}
      </div>{" "}
    </div>
  );
};

export default STAYardMWData;
